import { createQueryClient } from "@flows.cash/core";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

// Create the query client
const queryClient = createQueryClient();

// Create a persister
const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'FLOWS_CASH_QUERY_CACHE',
});

// Enable persistence
persistQueryClient({
  queryClient,
  persister,
  maxAge: 1000 * 60 * 60 * 24, // 24 hours
});

export { queryClient };
